import styled from 'styled-components';
import BannerAppMobile from '../../../../assets/media/banners/resource-banner-app-mobile.png';
import BannerLatam from '../../../../assets/media/banners/banner-latam-silicon-valley.jpg'; // Ajusta la ruta según tu imagen
import CommonButton from '../../../../components/common/CommonButton';
import { useSelector } from 'react-redux';
import ModalInfoBanner from './ModalInfoBanner';
import { useState, useRef } from 'react';
import Carousel from 'react-elastic-carousel';

const PrincipalInfoBanner = () => {
    const { partner_id, name } = useSelector((state) => state.auth.user);
    const carouselRef = useRef(null);

    const [openModal, setOpenModal] = useState(false);

    const comportamientoInfo = {
        partner_id: partner_id,
        partner_name: name,
    };

    const handleBannerLatamClick = () => {
        window.open('https://www.aden.org/workshop-silicon-valley/', '_blank');
    };

    const handleBannerAppleClick = () => {
        window.open(
            'https://apps.apple.com/us/app/aden-acr%C3%B3polis/id6737446349',
            '_blank'
        );
    };

    const handleBannerPlayStoreClick = () => {
        window.open(
            'https://play.google.com/store/apps/details?id=com.aden.acropolis&hl=es_419&pli=1',
            '_blank'
        );
    };

    return (
        <>
            <ModalInfoBanner
                open={openModal}
                onClose={() => setOpenModal(false)}
            />
            <CarouselWrapper>
                <StyledCarousel
                    ref={carouselRef}
                    itemsToShow={1}
                    showArrows={false}
                    pagination={true}
                    enableAutoPlay={true}
                    autoPlaySpeed={5000}
                >
                    {/* Banner 1: App Mobile */}
                    <Container backgroundImage={BannerAppMobile}>
                        <TextSection>
                            <h1>
                                <b>¡NUEVA APP ADEN ACRÓPOLIS!</b> <br />
                                Descubre y potencia tu experiencia de
                                aprendizaje.
                            </h1>
                        </TextSection>
                        <ButtonSection>
                            <CommonButton
                                variant="text"
                                label="¡Descarga para iOS!"
                                onClick={handleBannerAppleClick}
                                data-behaviour-action={'banner_app_mobile'}
                                data-behaviour-detail={JSON.stringify(
                                    comportamientoInfo
                                )}
                                FontAwesomeIconName="fa-brands fa-apple"
                            />
                            <CommonButton
                                variant="text"
                                label="¡Descarga para Android!"
                                onClick={handleBannerPlayStoreClick}
                                data-behaviour-action={
                                    'banner_app_mobile_download'
                                }
                                data-behaviour-detail={JSON.stringify(
                                    comportamientoInfo
                                )}
                                FontAwesomeIconName="fa-brands fa-google-play"
                            />
                        </ButtonSection>
                    </Container>

                    {/* Banner 2: LATAM Silicon Valley */}
                    <BannerLatamContainer
                        backgroundImage={BannerLatam}
                        onClick={handleBannerLatamClick}
                        data-behaviour-action={'banner_latam_silicon_valley'}
                        data-behaviour-detail={JSON.stringify(
                            comportamientoInfo
                        )}
                    />
                </StyledCarousel>
            </CarouselWrapper>
        </>
    );
};

export default PrincipalInfoBanner;

const CarouselWrapper = styled.div`
    width: 100%;
    position: relative;
`;

const StyledCarousel = styled(Carousel)`
    .rec.rec-arrow {
        display: none;
        visibility: hidden;
    }

    .rec.rec-pagination {
        position: absolute;
        bottom: -25px;
        left: 50%;
        transform: translateX(-50%);
    }

    .rec.rec-dot {
        background-color: #d9d9d9;
        box-shadow: none;
        width: 10px;
        height: 10px;

        &.rec.rec-dot_active {
            background-color: #b31d15;
        }
    }
`;

const Container = styled.div`
    position: relative;
    width: calc(100% - 2rem);
    height: 171px;
    border-radius: 30px;
    background-color: #b31d15;
    background-image: url(${(p) => p.backgroundImage});
    background-repeat: no-repeat;
    background-position: right;
    background-size: contain;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 2rem;
    padding: 0 2rem;

    @media (width < 1500px) {
        height: 139px;
        gap: 1rem;
    }

    @media (width < 768px) {
        background-image: none;
        justify-content: center;
        flex-direction: column;
        padding: 1.5rem 1rem;
        gap: 1rem;
    }
`;

const TextSection = styled.div`
    flex: 0 0 33.33%;
    display: flex;
    align-items: center;
    justify-content: center;

    h1 {
        color: #fff;
        font-size: 22px;
        font-weight: 400;
        line-height: 1.3;
        text-align: center;

        b {
            font-weight: 700;
        }
    }

    @media (width < 1500px) {
        h1 {
            font-size: 18px;
        }
    }

    @media (width < 768px) {
        flex: 0 0 auto;
        width: 100%;

        h1 {
            font-size: 16px;
            text-align: center;

            b {
                font-weight: 900;
            }
        }
    }
`;

const ButtonSection = styled.div`
    flex: 0 0 33.33%;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    justify-content: center;
    align-items: center;
    transform: translateX(-50px);

    button {
        width: fit-content;

        :hover {
            box-shadow:
                0px 3px 6px 0px #0000003b,
                0px 3px 6px 0px #00000029;
        }
    }

    @media (width < 1500px) {
        gap: 0.6rem;
        transform: translateX(0);
        button {
            font-size: 14px;
            padding: 0.6rem 1rem;
        }
    }

    @media (width < 768px) {
        flex: 0 0 auto;
        width: 100%;
        align-items: stretch;
        gap: 0.5rem;
        transform: translateX(0);

        button {
            width: 100%;
            font-size: 13px;
        }
    }
`;

const BannerLatamContainer = styled.div`
    position: relative;
    width: 100%;
    height: 171px;
    border-radius: 30px;
    background-image: url(${(p) => p.backgroundImage});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    cursor: pointer;

    @media (width < 1500px) {
        height: 139px;
    }
`;
